// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g-root {
  --dl-navigation-breadcrumbs-height: 28px;
  --dl-revision-panel-top-offset: 40px;
  --dl-color-border: var(--g-color-line-generic);
  --dl-color-border-solid: var(--g-color-line-generic-solid);
  --dl-color-progress-bar: var(--g-color-text-info);
  --dl-color-progress-bar-failed: var(--g-color-base-danger-heavy);
  --dl-color-field-dimenson: var(--g-color-base-positive-light);
  --dl-color-field-dimenson-hover: var(--g-color-base-positive-light-hover);
  --dl-color-field-measure: var(--g-color-base-info-light);
  --dl-color-field-measure-hover: var(--g-color-base-info-light-hover);
  --dl-color-field-dimenson-solid: var(--g-color-text-positive);
  --dl-color-field-measure-solid: var(--g-color-text-info);
  --dl-color-entity-chart-wizard: #5282ff;
  --dl-color-entity-chart-ql: #9f6fee;
  --dl-color-entity-chart-editor: #e18c1e;
  --dl-color-entity-connection: #9a32a6;
  --dl-color-entity-dataset: #0abe05;
  --dl-color-entity-dashboard: #ff8c3c;
  --dl-color-widget-background: var(--g-color-base-float);
  --dl-color-text-workbook-icon: var(--g-color-text-dark-primary);
  --dl-viz-icon-main-color: #3d97f2;
  --dl-viz-icon-secondary-color: #ff6a59;
}
.g-root_theme_light {
  --g-color-private-cool-grey-20-solid: rgb(245, 246, 247);
  --ds-color-relation-line: #d9d9d9;
  --ds-color-avatar: #ededed;
  --w-local-item-border: rgba(0, 0, 0, 0.5);
  --w-dataset-item-border-hover: rgba(0, 0, 0, 0.15);
  --w-disabled-item-background: rgba(0, 0, 0, 0.07);
  --dl-color-contrast-4: rgba(0, 0, 0, 0.04);
  --dl-color-base-workbook-icon: #d1dfff;
  --dl-filter-ymap-background: none;
  --dl-filter-ymap-heatmap: none;
  --dl-color-ymap-background: #fafafa;
  --dl-filter-zoom-control: none;
  --dl-color-dashboard-background: var(--g-color-private-cool-grey-20-solid);
  --dl-color-fixed-header-background: var(--g-color-private-cool-grey-100-solid);
}
.g-root_theme_light-hc {
  --ds-color-relation-line: #d9d9d9;
  --ds-color-avatar: #ededed;
  --w-local-item-border: rgba(0, 0, 0, 0.5);
  --w-dataset-item-border-hover: rgba(0, 0, 0, 0.15);
  --w-disabled-item-background: rgba(0, 0, 0, 0.07);
  --dl-color-contrast-4: rgba(0, 0, 0, 0.04);
  --dl-color-base-workbook-icon: #a8c3ff;
  --dl-filter-ymap-background: none;
  --dl-filter-ymap-heatmap: none;
  --dl-color-ymap-background: #fafafa;
  --dl-filter-zoom-control: none;
  --dl-color-dashboard-background: var(--g-color-private-cool-grey-50-solid);
  --dl-color-fixed-header-background: var(--g-color-private-cool-grey-150-solid);
}
.g-root_theme_dark {
  --g-color-private-white-20-solid: rgb(49, 48, 55);
  --ds-color-relation-line: #4c4b51;
  --ds-color-avatar: #3b3a41;
  --w-local-item-border: rgba(255, 255, 255, 0.5);
  --w-dataset-item-border-hover: rgba(255, 255, 255, 0.15);
  --w-disabled-item-background: rgba(255, 255, 255, 0.07);
  --dl-color-contrast-4: rgba(255, 255, 255, 0.04);
  --dl-color-base-workbook-icon: #c2d0f0;
  --dl-filter-ymap-background: invert(0.9) saturate(0.4) hue-rotate(-30deg);
  --dl-filter-ymap-heatmap: invert(0.9) saturate(0.4) hue-rotate(-30deg);
  --dl-color-ymap-background: transparent;
  --dl-filter-zoom-control: invert(1);
  --dl-color-dashboard-background: var(--g-color-private-white-20-solid);
  --dl-color-fixed-header-background: var(--g-color-base-background);
}
.g-root_theme_dark-hc {
  --g-color-private-white-20-solid: rgb(38, 39, 42);
  --ds-color-relation-line: #4c4b51;
  --ds-color-avatar: #3b3a41;
  --w-local-item-border: rgba(255, 255, 255, 0.5);
  --w-dataset-item-border-hover: rgba(255, 255, 255, 0.15);
  --w-disabled-item-background: rgba(255, 255, 255, 0.07);
  --dl-color-contrast-4: rgba(255, 255, 255, 0.04);
  --dl-color-base-workbook-icon: #c0d3fd;
  --dl-filter-ymap-background: invert(0.95) saturate(0.4) hue-rotate(-30deg);
  --dl-filter-ymap-heatmap: invert(0.95) saturate(0.4) hue-rotate(-30deg);
  --dl-color-ymap-background: transparent;
  --dl-filter-zoom-control: invert(1);
  --dl-color-dashboard-background: var(--g-color-private-white-20-solid);
  --dl-color-fixed-header-background: var(--g-color-base-background);
}

.revisions {
  overflow: auto;
  width: 100%;
  height: 100%;
}
.revisions__spin-wrap {
  display: flex;
  justify-content: center;
  height: 20px;
  margin: 20px 0;
}
.revisions__spin {
  margin-right: 4px;
}
.revisions__empty {
  padding: 0 20px 16px;
}
.revisions__content {
  width: 100%;
}
.revisions .revisions__btn-diff {
  margin-left: 32px;
  margin-bottom: 20px;
  width: max-content;
  flex-shrink: 0;
}
.revisions__item {
  display: flex;
  align-items: center;
  vertical-align: top;
  height: 40px;
  flex-shrink: 0;
  padding-left: 12px;
}
.revisions__item:hover:not(.revisions__item_current) {
  background-color: var(--g-color-base-simple-hover);
  cursor: pointer;
}
.revisions__item_current {
  background-color: var(--g-color-base-selection);
}
.revisions__release-status {
  flex-shrink: 0;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.revisions__release-mark {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--g-color-text-info);
}
.revisions__time-version {
  flex: 1 0 124px;
  display: flex;
  overflow: hidden;
  padding-left: 4px;
}
.revisions__user {
  flex: 2 1 25%;
  display: flex;
  overflow: hidden;
  margin: 0 5px 0 15px;
  white-space: nowrap;
}
.revisions__user-wrap {
  overflow: hidden;
}
.revisions__user-card::first-letter {
  color: var(--g-color-text-danger);
  overflow: hidden;
  text-overflow: hidden;
}
.revisions__user-link {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
}
.revisions__publish-status {
  flex: 1 0 120px;
  display: flex;
  overflow: hidden;
  justify-content: center;
}
.revisions__actions {
  flex: 0 0 120px;
  display: flex;
  align-items: center;
  overflow: hidden;
  min-width: 120px;
}
.revisions__dropdown {
  margin-left: auto;
  margin-right: 32px;
}
.revisions__progress-status {
  display: flex;
  align-items: center;
}
.revisions__progress-text {
  color: var(--g-color-text-secondary);
}
.revisions__loader-wrap {
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/ui/styles/variables.scss","webpack://./src/ui/components/Revisions/Revisions.scss"],"names":[],"mappings":"AA6BA;EACI,wCAAA;EACA,oCAAA;EAEA,8CAAA;EACA,0DAAA;EACA,iDAAA;EACA,gEAAA;EAEA,6DAAA;EACA,yEAAA;EACA,wDAAA;EACA,oEAAA;EACA,6DAAA;EACA,wDAAA;EAEA,uCAAA;EACA,mCAAA;EACA,uCAAA;EACA,qCAAA;EACA,kCAAA;EACA,oCAAA;EAEA,uDAAA;EAEA,+DAAA;EAEA,iCAAA;EACA,sCAAA;AClCJ;ADoCI;EAEI,wDAAA;EAEA,iCAAA;EACA,0BAAA;EACA,yCAAA;EACA,kDAAA;EACA,iDAAA;EACA,0CAAA;EACA,sCAAA;EACA,iCAAA;EACA,8BAAA;EACA,mCAAA;EACA,8BAAA;EACA,0EAAA;EACA,8EAAA;ACpCR;ADuCI;EACI,iCAAA;EACA,0BAAA;EACA,yCAAA;EACA,kDAAA;EACA,iDAAA;EACA,0CAAA;EACA,sCAAA;EACA,iCAAA;EACA,8BAAA;EACA,mCAAA;EACA,8BAAA;EACA,0EAAA;EACA,8EAAA;ACrCR;ADwCI;EACI,iDAAA;EAEA,iCAAA;EACA,0BAAA;EACA,+CAAA;EACA,wDAAA;EACA,uDAAA;EACA,gDAAA;EACA,sCAAA;EACA,yEAAA;EACA,sEAAA;EACA,uCAAA;EACA,mCAAA;EACA,sEAAA;EACA,kEAAA;ACvCR;AD0CI;EACI,iDAAA;EAEA,iCAAA;EACA,0BAAA;EACA,+CAAA;EACA,wDAAA;EACA,uDAAA;EACA,gDAAA;EACA,sCAAA;EACA,0EAAA;EACA,uEAAA;EACA,uCAAA;EACA,mCAAA;EACA,sEAAA;EACA,kEAAA;ACzCR;;AApFA;EAEI,cAAA;EACA,WAAA;EACA,YAAA;AAsFJ;AApFI;EACI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AAsFR;AAnFI;EACI,iBAAA;AAqFR;AAlFI;EACI,oBAAA;AAoFR;AAjFI;EACI,WAAA;AAmFR;AAhFI;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAkFR;AA/EI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AAiFR;AA/EQ;EACI,kDAAA;EACA,eAAA;AAiFZ;AA9EQ;EACI,+CAAA;AAgFZ;AA5EI;EACI,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AA8ER;AA3EI;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,0CAAA;AA6ER;AA1EI;EACI,eAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;AA4ER;AAzEI;EACI,aAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AA2ER;AAxEI;EACI,gBAAA;AA0ER;AAvEI;EACI,iCAAA;EACA,gBAAA;EACA,qBAAA;AAyER;AAtEI;EACI,cAAA;EACA,uBAAA;EACA,gBAAA;AAwER;AArEI;EACI,eAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;AAuER;AApEI;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAsER;AAnEI;EACI,iBAAA;EACA,kBAAA;AAqER;AAlEI;EACI,aAAA;EACA,mBAAA;AAoER;AAjEI;EACI,oCAAA;AAmER;AAhEI;EACI,aAAA;EACA,uBAAA;AAkER","sourcesContent":[null,".g-root {\n  --dl-navigation-breadcrumbs-height: 28px;\n  --dl-revision-panel-top-offset: 40px;\n  --dl-color-border: var(--g-color-line-generic);\n  --dl-color-border-solid: var(--g-color-line-generic-solid);\n  --dl-color-progress-bar: var(--g-color-text-info);\n  --dl-color-progress-bar-failed: var(--g-color-base-danger-heavy);\n  --dl-color-field-dimenson: var(--g-color-base-positive-light);\n  --dl-color-field-dimenson-hover: var(--g-color-base-positive-light-hover);\n  --dl-color-field-measure: var(--g-color-base-info-light);\n  --dl-color-field-measure-hover: var(--g-color-base-info-light-hover);\n  --dl-color-field-dimenson-solid: var(--g-color-text-positive);\n  --dl-color-field-measure-solid: var(--g-color-text-info);\n  --dl-color-entity-chart-wizard: #5282ff;\n  --dl-color-entity-chart-ql: #9f6fee;\n  --dl-color-entity-chart-editor: #e18c1e;\n  --dl-color-entity-connection: #9a32a6;\n  --dl-color-entity-dataset: #0abe05;\n  --dl-color-entity-dashboard: #ff8c3c;\n  --dl-color-widget-background: var(--g-color-base-float);\n  --dl-color-text-workbook-icon: var(--g-color-text-dark-primary);\n  --dl-viz-icon-main-color: #3d97f2;\n  --dl-viz-icon-secondary-color: #ff6a59;\n}\n.g-root_theme_light {\n  --g-color-private-cool-grey-20-solid: rgb(245, 246, 247);\n  --ds-color-relation-line: #d9d9d9;\n  --ds-color-avatar: #ededed;\n  --w-local-item-border: rgba(0, 0, 0, 0.5);\n  --w-dataset-item-border-hover: rgba(0, 0, 0, 0.15);\n  --w-disabled-item-background: rgba(0, 0, 0, 0.07);\n  --dl-color-contrast-4: rgba(0, 0, 0, 0.04);\n  --dl-color-base-workbook-icon: #d1dfff;\n  --dl-filter-ymap-background: none;\n  --dl-filter-ymap-heatmap: none;\n  --dl-color-ymap-background: #fafafa;\n  --dl-filter-zoom-control: none;\n  --dl-color-dashboard-background: var(--g-color-private-cool-grey-20-solid);\n  --dl-color-fixed-header-background: var(--g-color-private-cool-grey-100-solid);\n}\n.g-root_theme_light-hc {\n  --ds-color-relation-line: #d9d9d9;\n  --ds-color-avatar: #ededed;\n  --w-local-item-border: rgba(0, 0, 0, 0.5);\n  --w-dataset-item-border-hover: rgba(0, 0, 0, 0.15);\n  --w-disabled-item-background: rgba(0, 0, 0, 0.07);\n  --dl-color-contrast-4: rgba(0, 0, 0, 0.04);\n  --dl-color-base-workbook-icon: #a8c3ff;\n  --dl-filter-ymap-background: none;\n  --dl-filter-ymap-heatmap: none;\n  --dl-color-ymap-background: #fafafa;\n  --dl-filter-zoom-control: none;\n  --dl-color-dashboard-background: var(--g-color-private-cool-grey-50-solid);\n  --dl-color-fixed-header-background: var(--g-color-private-cool-grey-150-solid);\n}\n.g-root_theme_dark {\n  --g-color-private-white-20-solid: rgb(49, 48, 55);\n  --ds-color-relation-line: #4c4b51;\n  --ds-color-avatar: #3b3a41;\n  --w-local-item-border: rgba(255, 255, 255, 0.5);\n  --w-dataset-item-border-hover: rgba(255, 255, 255, 0.15);\n  --w-disabled-item-background: rgba(255, 255, 255, 0.07);\n  --dl-color-contrast-4: rgba(255, 255, 255, 0.04);\n  --dl-color-base-workbook-icon: #c2d0f0;\n  --dl-filter-ymap-background: invert(0.9) saturate(0.4) hue-rotate(-30deg);\n  --dl-filter-ymap-heatmap: invert(0.9) saturate(0.4) hue-rotate(-30deg);\n  --dl-color-ymap-background: transparent;\n  --dl-filter-zoom-control: invert(1);\n  --dl-color-dashboard-background: var(--g-color-private-white-20-solid);\n  --dl-color-fixed-header-background: var(--g-color-base-background);\n}\n.g-root_theme_dark-hc {\n  --g-color-private-white-20-solid: rgb(38, 39, 42);\n  --ds-color-relation-line: #4c4b51;\n  --ds-color-avatar: #3b3a41;\n  --w-local-item-border: rgba(255, 255, 255, 0.5);\n  --w-dataset-item-border-hover: rgba(255, 255, 255, 0.15);\n  --w-disabled-item-background: rgba(255, 255, 255, 0.07);\n  --dl-color-contrast-4: rgba(255, 255, 255, 0.04);\n  --dl-color-base-workbook-icon: #c0d3fd;\n  --dl-filter-ymap-background: invert(0.95) saturate(0.4) hue-rotate(-30deg);\n  --dl-filter-ymap-heatmap: invert(0.95) saturate(0.4) hue-rotate(-30deg);\n  --dl-color-ymap-background: transparent;\n  --dl-filter-zoom-control: invert(1);\n  --dl-color-dashboard-background: var(--g-color-private-white-20-solid);\n  --dl-color-fixed-header-background: var(--g-color-base-background);\n}\n\n.revisions {\n  overflow: auto;\n  width: 100%;\n  height: 100%;\n}\n.revisions__spin-wrap {\n  display: flex;\n  justify-content: center;\n  height: 20px;\n  margin: 20px 0;\n}\n.revisions__spin {\n  margin-right: 4px;\n}\n.revisions__empty {\n  padding: 0 20px 16px;\n}\n.revisions__content {\n  width: 100%;\n}\n.revisions .revisions__btn-diff {\n  margin-left: 32px;\n  margin-bottom: 20px;\n  width: max-content;\n  flex-shrink: 0;\n}\n.revisions__item {\n  display: flex;\n  align-items: center;\n  vertical-align: top;\n  height: 40px;\n  flex-shrink: 0;\n  padding-left: 12px;\n}\n.revisions__item:hover:not(.revisions__item_current) {\n  background-color: var(--g-color-base-simple-hover);\n  cursor: pointer;\n}\n.revisions__item_current {\n  background-color: var(--g-color-base-selection);\n}\n.revisions__release-status {\n  flex-shrink: 0;\n  width: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n.revisions__release-mark {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: var(--g-color-text-info);\n}\n.revisions__time-version {\n  flex: 1 0 124px;\n  display: flex;\n  overflow: hidden;\n  padding-left: 4px;\n}\n.revisions__user {\n  flex: 2 1 25%;\n  display: flex;\n  overflow: hidden;\n  margin: 0 5px 0 15px;\n  white-space: nowrap;\n}\n.revisions__user-wrap {\n  overflow: hidden;\n}\n.revisions__user-card::first-letter {\n  color: var(--g-color-text-danger);\n  overflow: hidden;\n  text-overflow: hidden;\n}\n.revisions__user-link {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.revisions__publish-status {\n  flex: 1 0 120px;\n  display: flex;\n  overflow: hidden;\n  justify-content: center;\n}\n.revisions__actions {\n  flex: 0 0 120px;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  min-width: 120px;\n}\n.revisions__dropdown {\n  margin-left: auto;\n  margin-right: 32px;\n}\n.revisions__progress-status {\n  display: flex;\n  align-items: center;\n}\n.revisions__progress-text {\n  color: var(--g-color-text-secondary);\n}\n.revisions__loader-wrap {\n  display: flex;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
